// spektrix.js

// Spektrix JS

// spektrix.js

; (function ($) {
    //'use strict'

    var SpektrixTheme = {
        /** @type {Object} Page title replacement tokens */
        page_titles: {
            /*
            'Choose Seats': 'Choose your ticket',
            'Start Checkout': 'Start checkout'
            */
        },

        /** @type {Object} Form label replacement tokens */
        form_labels: {
            Phone: 'Phone number'
        },

        /**
         * Detect touch device
         * @return void
         */
        touch_device: function () {
            if ('ontouchstart' in window || navigator.maxTouchPoints) {
                $('html').removeClass('no-touch')
            } else {
                $('html').addClass('no-touch')
            }
        },

        /**
         * Add page title
         * @return void
         */
        add_title: function () {
            $('.EditTickets .Progress').after('<h1>Choose your ticket</h1>')
            $('.AddGiftVoucher .Progress').after('<h1>Buy Gift Vouchers</h1>')
        },

        /**
         * Replace page title
         * @return void
         */
        replace_title: function () {
            var title = $('h1').text()

            if (this.page_titles[title]) {
                $('h1').text(this.page_titles[title])
            }
        },

        /**
         * Replace form labels
         * @return void
         */
        replace_labels: function () {
            var theme = this
            $('label, .Label').each(function () {
                var label = $(this).html()
                $(this).html(label.replace(':', ''))

                /*
                label = $(this).text()
        
                  if (theme.form_labels[label]) {
                      $(this).html(label.replace(':', ''))
                }
                */
            })
        },

        /**
         * Move or generative subnav
         * @return void
         */
        update_subnav: function () {
            $('.PrivacyPolicy').append($('.Progress'))

            if (true) {
                var selection_current =
                    $(
                        '.ChooseSeats, .SupplementaryEventsPage, .EditTickets, .AddGiftVoucher.SpektrixPage'
                    ).length > 0
                        ? 'Current'
                        : ''
                var basket_current = $('.Basket2, .Basket2').length > 0 ? 'Current' : ''
                var checkout_current =
                    !selection_current && !basket_current ? 'Current' : ''
                //$('.spx-header-container').length > 0 ? 'Current' : ''

                var subnav =
                    "<div class='Progress'><ul><li class='" +
                    selection_current +
                    "'>Your Selection</li><li class='" +
                    basket_current +
                    "'>Basket</li><li class='" +
                    checkout_current +
                    "'>Checkout</li></ul></div>"
                $('.SpektrixPage, .spx-header-container').prepend(subnav)
            }
        },

        /**
         * Replace 'Total' with 'Price'
         * @return void
         */
        total_to_price: function () {
            $('.Total .Title').each(function () {
                var initial = $(this).text()
                if (initial) {
                    initial = initial.trim()

                    if (initial === 'Total') {
                        $(this).text('Price')
                    }
                }
            })
        },

        /**
         * Wrap dropdowns
         * @return void
         */
        select_wrap: function () {
            $('select').wrap('<div class="select-wrap" />')
        },

        /**
         * Add privacy policy link to checkout
         * @return void
         */
        add_privacy_text: function () {
            $('.spx-heading-title__checkout').after(
                "<div class='spx-belgrade-privacy'>We are committed to your privacy. To view our Privacy Policy click <a href='#' target='_blank'>here</a></div>"
            )
        },

        /**
         * Move input area inside the content box
         * @return void
         */
        move_error: function () {
            $('.SpektrixPage h1').after($('form > .ErrorMessage'))
        },

        /**
         * Duplicate 'Continue to Basket' button on 'Add extra' page
         * @return void
         */
        clone_skip_button: function () {
            $('.SupplementaryEventsPage > div:last-of-type input').each(function () {
                $(
                    '#ctl00_ContentPlaceHolder_SupplementaryEventsWikiTextViewer h1'
                ).after(
                    $(this)
                        .clone(true)
                        .attr('id', $(this).attr('id') + '-clone')
                        .addClass('basket-btn-clone')
                )
            })
        },

        /**
         * Replace fixed height and width of seatmap with responsive padding
         * @return void
         */
        responsive_seatmap: function () {
            $('#ctl00_ContentPlaceHolder_SeatingAreaControl_ContainerDiv').each(
                function () {
                    var initialHeight = $(this).outerHeight()
                    var initialWidth = $(this).outerWidth()

                    // Change the 'top' positioning of area links from pixels to percentage of total height
                    $(this)
                        .find('a')
                        .each(function () {
                            var top = $(this).css('top')
                            var initialTop = top

                            top = top.replace('px', '')
                            top = parseInt(top)
                            top = top / initialHeight
                            top = Math.round(top * 10000) / 100
                            top = top + '%'

                            $(this).css('top', top)
                        })

                    $(this).css(
                        'padding-bottom',
                        100 * (initialHeight / initialWidth) + '%'
                    )
                    $(this).css('height', 0)
                    $(this).css('width', '100%')
                }
            )
        },

        /** Remove comma after event title and ! from Priority Booking tag */
        format_event_title: function () {
            // var regex = /span>(,)/gm
            // var subst = 'span>'
            // var str = $('.EventDetails').html(function(){
            //     return $(this).html().replace(regex, subst)
            // })
            // var regex = /(!)/gm
            // var subst = ''
            // var str = $('b.PriorityBooking').text(function(){
            //     return $(this).text().replace(regex, subst)
            // })
        },

        /** Add labels to checkboxes */
        create_checkbox_labels: function () {
            // Delete ticket
            $('td.Delete').each(function () {
                var input = $(this).find('input')
                var input_id = input.attr('id')

                var label = $('<label/>', {
                    for: input_id
                })

                input.after(label)
            })

            // // Terms & Conditions
            // if ($('.TermsAndConditions').is('div')) {
            //     var tc_label = $('.TermsAndConditions label')
            //     var tc_input = $('.TermsAndConditions input')

            //     tc_input.after(tc_label)
            // }
        },

        venue_details: function () {
            // if ($('.VenueName').text() == 'Unknown') {
            //     $('.VenueName').remove()
            //     var regex = /(,)/gm
            //     var subst = ''
            //     var str = $('.AreaAndVenueDetails').html(function(){
            //         return $(this).html().replace(regex, subst)
            //     })
            // }
            // if ($('.VenueAddress').text() == 'Unknown') {
            //     $('.VenueAddress').remove()
            // }
        },

        hideFreeMembership: function () {
            // if($('.Memberships .Membership').length > 1){
            //     $('.Memberships .Membership:last').hide()
            // }
        },

        move_elements: function () {
            $('.LoginLogout .LoginForm').append($('.Buttons'))

            $('.Checkout h1').after($('.PrivacyPolicy').clone())
            $('.SummarySection .PrivacyPolicy')
                .addClass('SummaryPrivacyPolicy')
                .removeClass('PrivacyPolicy')

            $('.TermsAndConditions').append($('.TermsAndConditions label'))

            $('.ChooseSeatsHeading').prepend($('.ChooseSeatsHeading h1'))
            $('.ChooseSeatsHeading div').addClass('ChooseSeatsText')
            $('.EventDetails, .AreaAndVenueDetails, .InstanceCalendar')
                .last()
                .after($('.ChooseSeatsHeading div'))

            $('#ctl00_ContentPlaceHolder_ChangeMySeatsLink').addClass(
                'Button GreyButton'
            )
            $('.Buttons').prepend($('#ctl00_ContentPlaceHolder_ChangeMySeatsLink'))

            $('.DeliveryOption .Cmsn_Caption').each(function () {
                $(this)
                    .siblings('label')
                    .append(this)
            })

            $('.SupplementaryEventsPage .Event_Text > div:first-of-type').append(
                $('.SupplementaryEventsPage img')
            )

            // $('.AddCard .AddAddressesButton').after( $('.AddCard [value="Continue"]') )
            // $('.Buttons').prepend($('#ctl00_ContentPlaceHolder_ChangeMySeatsLink'))
            // $('#ctl00_ContentPlaceHolder_ChangeMySeatsLink').text('Change my seats')
            // $('.spx-subsection-container__checkout--gift-aid-info.spx-intent-accordion').prepend($('.spx-button-primary__checkout--gift-aid'))
            // $('.spx-field-container__checkout--credit').text('Redeem voucher')
            // if ($('.EditTicketsHeading').is('h2')) {
            //     var event_heading = $('h1.EditTicketsHeading').html()
            //     $('h2.EditTicketsHeading').prepend($(event_heading).addClass('EventHeading'))
            //     $('h1.EditTicketsHeading').html('<span>Select tickets</span>')
            // }
            // if ($('.ChooseSeats .EventDetails').is('p')) {
            //     var event_deatail_html = $('.ChooseSeats .EventDetails').html()
            //     $('.ChooseSeats .EventDetails').html(event_deatail_html.replace(', ', ''))
            // }
        },

        /** Send title to parent */
        send_message: function () {
            /*
            var header_height = $('h1').outerHeight() + $('.Progress').outerHeight()
            var message = 'header_height:' + header_height + 'px'
            */
            var title = $('h1').text().replace('.', '')
            var message = 'title:' + title
            window.parent.postMessage(message, '*')
            $('h1').hide()
        },

        /** Resize iFrame after any JS content changes */
        resize_iframe: function () {
            //console.log('Resize iFrame')
            if (
                $(
                    '.ChooseSeats, .SupplementaryEventsPage, .Basket2, .Basket2, .spx-header-container,' +
                    '#ctl00_ContentPlaceHolder_SeatingAreaControl_ContainerDiv,' +
                    '.SupplementaryEventsPage,' +
                    '.spx-heading-title__checkout,' +
                    '.EditTickets, .AddGiftVoucher, .MyAccount'
                ).length > 0
            ) {
                setTimeout(function () {
                    var newHeight = $('body').height()
                    newHeight = Math.round(newHeight)
                    newHeight += 100

                    var message = 'resize:' + newHeight
                    window.parent.postMessage(message, '*')
                    //console.log('Post message:', message)
                }, 200)
            }
        },

        checkout_link: function () {
            $('.CheckoutLink').removeAttr('target')
        },

        account() {

            if (! $('.MyAccount.SpektrixPage').length ) return

            var message = {'logged_in': true}
            console.log('ACCOUNT')
            console.log(message)
            window.parent.postMessage(message, '*')

            
        },

        run: function () {
            //console.log('RUN')

            this.touch_device()

            // this.checkout_link()

            this.move_elements()
            // this.venue_details()

            this.create_checkbox_labels()
            this.replace_title()
            this.replace_labels()
            //this.update_subnav()
            //this.total_to_price()
            this.select_wrap()
            //this.add_privacy_text()
            this.move_error()
            this.clone_skip_button()
            this.responsive_seatmap()
            this.add_title()
            // this.format_event_title()
            //this.send_message()
            //this.hideFreeMembership()

            this.account() 

            this.resize_iframe()
        }
    }

    $(function () {
        SpektrixTheme.run()
    })
})(jQuery)
